import {createApp} from 'vue';
import IndividualHours from './IndividualHours.vue';
import {createBootstrap} from 'bootstrap-vue-next';

$(document).ready(/\/course-management\/semester\/(\d*\/)?course$/.test(window.location.pathname)&&function() {
  $('#individual-hours-modal').one('show.bs.modal', function() {
    const container = $('#individual-hours-container');

    createApp(IndividualHours, container.data())
       .use(createBootstrap())
        .mount(container[0]);
  });
});
